import { PalletteProps } from '../../types/theme/pallette';
import styled from 'styled-components';

export const NotificationWrapper = styled.div`
  width: auto;
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  gap: 3px;
`;

export const Note = styled.p`
  color: ${({ theme }: PalletteProps) => theme.darkGray};
  line-height: 1.1rem;
  font-size: 0.6875rem;
  font-style: italic;
  text-align: center;
`;
